<script setup lang="ts">
import { twMerge } from "tailwind-merge";

import { useUser } from "@/composables/api/useUser";

const props = defineProps<{
  class?: string;
}>();
const { data: user } = useUser();
</script>

<template>
  <button
    type="button"
    :class="
      twMerge(
        'text-galbani flex size-12 cursor-pointer items-center justify-center rounded-full bg-white shadow-md',
        props.class,
        user?.current_mechanic === 'lactel' && 'text-lactel-blue',
      )
    "
  >
    <slot />
  </button>
</template>
